import type { ButtonHTMLAttributes } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
  size?: 'sm' | 'md' | 'lg';
}

// Paleta Aurora distrital — primary coral con shadow, secondary lavanda (accent-500),
// ghost outline coral, danger semantic. Shadows refuerzan jerarquía visual.
const VARIANT_CLASSES: Record<NonNullable<ButtonProps['variant']>, string> = {
  primary:
    'bg-distrito-500 text-white shadow-md shadow-distrito-500/30 hover:bg-distrito-600 hover:shadow-lg hover:shadow-distrito-500/40 active:bg-distrito-700 disabled:bg-distrito-300 disabled:shadow-none',
  secondary:
    'bg-accent-500 text-white shadow-md shadow-accent-500/30 hover:bg-accent-600 hover:shadow-lg hover:shadow-accent-500/40 active:bg-accent-700 disabled:bg-accent-300 disabled:shadow-none',
  ghost:
    'bg-transparent text-distrito-600 border-2 border-distrito-200 hover:bg-distrito-50 hover:border-distrito-300 active:bg-distrito-100 disabled:text-distrito-300 disabled:border-distrito-100',
  danger:
    'bg-red-600 text-white shadow-md shadow-red-600/30 hover:bg-red-700 hover:shadow-lg active:bg-red-800 disabled:bg-red-300 disabled:shadow-none',
};

const SIZE_CLASSES: Record<NonNullable<ButtonProps['size']>, string> = {
  sm: 'px-3 py-1.5 text-sm',
  md: 'px-4 py-2 text-sm font-semibold',
  lg: 'px-6 py-3 text-base font-semibold',
};

export function Button({ variant = 'primary', size = 'md', className = '', ...rest }: ButtonProps) {
  const base =
    'inline-flex items-center justify-center font-semibold rounded-lg transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-distrito-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed';
  return (
    <button
      type={rest.type ?? 'button'}
      className={`${base} ${VARIANT_CLASSES[variant]} ${SIZE_CLASSES[size]} ${className}`}
      {...rest}
    />
  );
}
